(() => {
  const observerOptions = {
    threshold: 0.01,
    rootMargin: "0px 0px 15% 0px",
  };

  const parseDelay = (value, fallback = 0) => {
    const parsed = Number.parseInt(value || `${fallback}`, 10);
    return Number.isNaN(parsed) ? fallback : parsed;
  };

  const setupAnimateElements = (root = document) => {
    const elements = root.querySelectorAll("[data-animate]");
    elements.forEach((el) => {
      const delay = parseDelay(el.dataset.delay, 0);
      el.style.setProperty("--promeal-anim-delay", `${delay}ms`);
    });
  };

  const setupStaggerGroups = (root = document) => {
    const groups = root.querySelectorAll("[data-animate-stagger]");
    groups.forEach((group) => {
      const baseDelay = parseDelay(group.dataset.staggerDelay, 100);
      const children = group.querySelectorAll(":scope > [data-animate]");
      children.forEach((child, index) => {
        const explicitDelay = child.dataset.delay;
        if (!explicitDelay) {
          child.style.setProperty("--promeal-anim-delay", `${index * baseDelay}ms`);
        }
      });
    });
  };

  const animateObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
      } else if (entry.target.hasAttribute("data-animate-repeat")) {
        entry.target.classList.remove("is-visible");
      }
    });
  }, observerOptions);

  const observeAnimateElements = (root = document) => {
    const elements = root.querySelectorAll("[data-animate]");
    elements.forEach((el) => animateObserver.observe(el));
  };

  const setupTimelineProgress = () => {
    const timelines = document.querySelectorAll("[data-how-it-works]");
    timelines.forEach((timeline) => {
      const progressLine = timeline.querySelector("[data-timeline-progress]");
      const ball = timeline.querySelector("[data-timeline-ball]");
      if (!progressLine || !ball) return;

      const updateProgress = () => {
        const rect = timeline.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const start = viewportHeight * 0.55;
        const end = rect.height + viewportHeight * 0.2;
        const traveled = start - rect.top;
        const progress = Math.max(0, Math.min(1, traveled / end));

        progressLine.style.transform = `scaleY(${progress})`;
        ball.style.top = `${progress * 100}%`;
      };

      updateProgress();
      window.addEventListener("scroll", updateProgress, { passive: true });
      window.addEventListener("resize", updateProgress);
    });
  };

  const revealInView = (root = document) => {
    const vh = window.innerHeight || document.documentElement.clientHeight;
    root.querySelectorAll("[data-animate]").forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > -vh * 0.25) {
        el.classList.add("is-visible");
      }
    });
  };

  const init = (root = document) => {
    setupAnimateElements(root);
    setupStaggerGroups(root);
    observeAnimateElements(root);
    revealInView(root);
    requestAnimationFrame(() => revealInView(root));
    setupTimelineProgress();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });
})();
